import React from "react";
import { Autocomplete, Button, CircularProgress, TextField } from "@mui/material";
import { Download } from "@mui/icons-material";

function FitroUserApps({
    dataLocales,
    loadingCargarLocales,
    localSelected,
    localSearch,
    localAutocompleteSearch,
    handleSearchLocal,
    handleAutocompleteSearchLocal,
    handleLocalSelected
}) {
    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-800">Usuarios por local</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Local por nombre</label>
                    <input
                        type="text"
                        value={localSearch}
                        onChange={(event) => handleSearchLocal(event.target.value)}
                        placeholder="Buscar usuarios por nombre del local"
                        className={inputBaseClass}
                    />
                </div>

                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Local (seleccionar)</label>
                    <Autocomplete
                        disablePortal
                        options={dataLocales || []}
                        fullWidth
                        loading={loadingCargarLocales}
                        value={localSelected || null}
                        inputValue={localAutocompleteSearch}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input" || reason === "clear") {
                                handleAutocompleteSearchLocal(newInputValue);
                            }
                        }}
                        onChange={(event, newValue) => {
                            handleLocalSelected(newValue);
                        }}
                        getOptionLabel={(option) => option?.nombre_fantasia || option?.nombre || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        loadingText="Cargando..."
                        noOptionsText="No hay opciones"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarLocales ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

export default FitroUserApps;